import * as React from "react";
import * as _ from 'lodash';
import * as ReactTags from "react-tag-autocomplete";
import { ITag } from "@nkr/models/index";
import { Panel, FormGroup, ControlLabel, FormControl, HelpBlock } from "react-bootstrap";
import { TagsWrapper } from "./styles";
import Switch from "react-switch";

interface IProps {
    tags: ITag[],
    suggestions: ITag[],
    emailOverride: string,
    onChange: (tags: ITag[], suggestions: ITag[]) => void,
    onEmailOverrideChange: (property: string, value: string) => void
}

const Gala = (props: IProps) => {
    const [expanded, setExpanded] = React.useState(true);

    const handleEmailOverrideChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        props.onEmailOverrideChange('emailOverride', e.currentTarget.value);
    };

    const handleAddTag = (tag: ITag) => {
        let tags = _.cloneDeep(props.tags);
        let tagSuggestions = _.cloneDeep(props.suggestions);

        if (tag.id == null) {
            let lastTag = _.maxBy(tags, (item) => item.id);
            let nextId = lastTag ? lastTag.id + 1 : 0;
            tags.push({ id: nextId, name: tag.name });
            tagSuggestions.push({ id: nextId, name: tag.name });
        } else {
            tags.push(tag);
        }

        props.onChange(tags, tagSuggestions);
    }

    const handleDeleteTag = (index: number) => {
        let tags = props.tags.filter((tag, tagIndex) => {
            return tagIndex != index;
        });

        props.onChange(tags, props.suggestions);
    }

    return (
        <Panel expanded={expanded} onToggle={() => { }}>
            <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Gala
                <Switch onChange={setExpanded} checked={expanded} height={20} width={40} uncheckedIcon={false} checkedIcon={false} />
            </Panel.Heading>
            <Panel.Collapse>
                <Panel.Body>
                    <FormGroup>
                        <ControlLabel>Tags</ControlLabel>
                        <TagsWrapper>
                            <ReactTags
                                tags={props.tags}
                                allowNew={true}
                                suggestions={props.suggestions}
                                handleDelete={handleDeleteTag}
                                handleAddition={handleAddTag} />
                        </TagsWrapper>
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Email Override</ControlLabel>
                        <FormControl
                            id="emailOverride"
                            value={props.emailOverride}
                            onChange={handleEmailOverrideChange}
                        />
                        <HelpBlock>Primary email will be used if not specified</HelpBlock>
                    </FormGroup>
                </Panel.Body>
            </Panel.Collapse>
        </Panel>
    );
}

export default Gala;